module.exports = "/_next/static/images/f0be62fcfb5779e445833a546b5d6f06-complexity@xs-2x.jpg";